const endpoints = {
  auth: {
    user:'/users',
    login: '/users/login',
    forgotPassword:'/users/forgotpassword',
    resetPassword:'users/passwordreset',
    changePassword:'users/changepassword',
    enable2Fa:'users/enable2fa',
    generateqrcode:'users/generateqrcode',
    verifyotp:'users/verifyotp',
  },
  dashboard:{
    records:'/dashboard/records',
  },
  home:{
    dashboard:'/home/dashboard',
  },
  members:'/members',
  membersImports:'/members/import',
  loanPaymentInfo:'/loanpaymentinfos',
  loanPaymentImport:'/loanpaymentinfos/import',
  loanInfo:'/loaninfos',
  loanInfoImports:'/loaninfos/import',
  screening:'/screenings',
  screeningRelations:'/screenings/additional',
  screeningRelationsDropDown:'/screeningrelations',
  screeningPurpose:'/screeningpurposes',
  screeningMaster:'/screeningmasters',
  user:'/users',
  
  
  districts:'/districts',
  localbodies:'/localbodies',
  states:'/states',
  screenTypes:'/screenTypes',
  // institution: '/institutions',
  screen:{
    base:'/screens',
    status:'/screens/status',
    dropdown:'/screens/dropdown',
    screenSummary:'/screens/summary',
    syncWithApp:'/screens/syncwithapp',

  },
  frames: '/frames',
  framesDropdown: '/frames/dropdown',
  framesSummary: '/frames/summary',
  ScreenFrameConfigs: {
    base:'/ScreenFrameConfigs',
    dropdown:'/ScreenFrameConfigs/dropdown',
    byScreenId: (screenId:number) => `/ScreenFrameConfigs/screen/${screenId}`,
    frameOrder:'/ScreenFrameConfigs/frameorder',
    status:'/ScreenFrameConfigs/status',

  },
  componentContent: '/componentcontents',
  componentContents:{
    base:'/componentcontents',
    history:'/componentcontents/history',
    dropdown:'/componentcontents/dropdown',
    order:'/componentcontents/order',
    details:(id:number) => `/componentcontents/${id}/allcontents`,
    publish:'/componentcontents/publish',
    approvalPendings:'/componentcontents/approvalpendings',
    approve:'/componentcontents/approve',
  },
  institution: {
    base:'/institutions',
    dropdown:'/institutions/dropdown',
    details:(id:number) => `/institutions/${id}`,
    category:'/institutioncategories/dropdown',
    addChild:'/institutions/addchildinstitution',
    childInstitutions:(parentInstitutionId:number) => `/institutions/childinstitutions/${parentInstitutionId}`,
    removeChild:(id:number) => `/institutions/removechildinstitution/${id}`,
  },
  institutioncategories:{
    base:'/institutioncategories',
    institutions:'/institutioncategories/institutions',
    dropdown:'/institutioncategories/dropdown',
    details:(id:number) => `/institutioncategories/${id}`,
  },
  designations:{
    base:'/designations',
    dropdown:'/designations/dropdown',
  },
  files:{
    base:'/files',
    contentLibrary:'/files/contentlibrary',
    update:'/files/update',
    usage:'/files/usage',
  },
  alerts:{
    base:'/alerts',
    details:(id:number) => `/alerts/${id}`,
    send:(id:number) => `/alerts/${id}/send`,
  },
  playbackHistory:{
    base:'/playbackhistory',
  }
};


export default endpoints
